var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9567 22.5716H10.1466C7.56444 22.5716 6.07825 20.9194 6.07825 18.8769C6.07825 17.1084 7.19912 15.7136 8.85966 15.2403C9.15026 11.9275 11.8736 9.42839 15.095 9.42839C17.5609 9.42839 19.5868 10.7651 20.6911 12.9571C23.7049 12.9571 25.9218 15.0161 25.9218 17.7477C25.9218 20.4544 23.7548 22.5716 20.9567 22.5716Z",
    fill: "url(#paint0_linear_10214_631)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10214_631",
    x1: 11.8023,
    y1: 12.3035,
    x2: 16.9325,
    y2: 27.1784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FC0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02D);
export default __webpack_public_path__ + "static/media/02d.21f765cca4f8a39f1d7dc19160c91607.svg";
export { ForwardRef as ReactComponent };